export { Icon } from './Icon.component';
